import Div from '@ui/layout/Div'

const useHtmlRenderer = () => {
  const renderHtml = htmlContent => {
    return <Div otherProps={{ dangerouslySetInnerHTML: { __html: htmlContent } }} />
  }

  return renderHtml
}

export default useHtmlRenderer